import React from "react";
import ClaroImage from '../../../molecules/ClaroImage'
import ClaroInputField from "../../../atoms/ClaroInputField";
import ClaroDiv from "../../../atoms/ClaroDiv";
import ClaroInputButton from "../../../atoms/ClaroInputButton"
import styled from 'styled-components';
import { validateUserAgent } from "../../utils";

const InputContainer = styled.div`
    border: 1px solid #c4c4c4;
    margin: 0% 0% 0% 0%;
    border-radius : 5px;
    background: #fff;
        &:hover {
        ${props => props.valid ? '1px solid black' : '1px solid #d92c27'};
    }
`;

const TextOption = styled.p`
    color: #7f7d7f;
    font-size: 12px;
    font-weight: normal;
    display: inline;
    vertical-align: "middle";
    padding: ${props => props.padding ? props.padding : "0% 0% 0% 0%"};
`;

class SelectInputSears extends React.Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    render(){ 
        let { isValid, imageCard, mark } = this.props
        const stylesButton = {
            "src": "/images/flecha_abajo.png",
            "srcImgClaroSocio": "/images/icono_flecha_detalle.svg",
            "height": "15.1em",
            "width": "17em",
        }

        let widthInput = "77%"
        if(mark === "999"){
            widthInput = "40%"
        }else if(mark === "997"){
            widthInput = "27%"
        }
        return(
            <InputContainer valid= {isValid}>
                {
                    this.props.imageCard ?
                        <img 
                            src= {imageCard } 
                            height="22px" 
                            width="10%"
                            style={{padding:"0px .3em", verticalAlign: "middle"}}
                        />
                    :
                    <></>
                }
                {
                    mark == "999"?
                        <img 
                            src= {`${process.env.REACT_APP_IMAGES}logo_n2_inbursa.png`} 
                            height="15px" 
                            width="35%"
                            style={{verticalAlign: "middle"}}
                        />
                    :
                    <></>
                }
                {
                    mark == "997"? <><TextOption>{"Crédito"}</TextOption><img
                        src={`${process.env.REACT_APP_IMAGES}logo_n2_inbursa.png`}
                        height="14px"
                        width={validateUserAgent() === "android" ? "35%" : "35%"}
                        style={{ padding: "4px 0px 0px 8px" }} /></>
                    :
                    <></>
                }
                <ClaroInputField 
                    borderBottom={"hidden"}
                    border={"none"}
                    height={"3em"}
                    width={widthInput}
                    padding= {"0px "}
                    phColor={"#c4c4c4"}
                    {...this.props.input} 
                    constraints={this.props.constraints} 
                    value= { this.props.value} 
                    name={this.props.input.field.input.name}
                    id = {this.props.id}
                    onClick= {(e) =>{this.props.handleInputButtonFunction(e, this.props.input.type)}}
                    readOnly={true}

                />
                {
                    <ClaroInputButton
                        borderBottom={this.props.borderBottom} 
                        {...stylesButton}
                        onClick= {(e) =>{this.props.handleInputButtonFunction(e, this.props.input.type)}}
                        style={{display:"inline", borderBottom:"none"}}
                    >
                    {
                        <ClaroImage {...stylesButton} isClaroPartner={this.props.isClaroPartner} widthClaroSocio={"15em"}/>
                    }
                    </ClaroInputButton>
                }
            </InputContainer>
        )
    }
}

export default SelectInputSears;